import { DoorGlassInstallation } from '../enums/door-glass-installation';
import { DoorStyle } from '../enums/door-style';

export function styleGlassInstallations(glassInstallations: DoorGlassInstallation[], style: DoorStyle) {
  if (style === DoorStyle.FLVC) {
    [...glassInstallations].filter(g => g !== DoorGlassInstallation.RCO).forEach(x => glassInstallations.remove(x));
  }
}
